/* @generated */

// ../src/layer/context.ts
import * as React from "react";
var MODAL_BASE_INDEX = 1e4;
var ELEVATED_BACKDROP_INDEX = 10;
var ELEVATED_BASE_INDEX = 11;
var LayerContext = React.createContext(null);

// ../src/layer/layer.tsx
import * as React2 from "react";
import * as ReactDOM from "react-dom";
import { useTheme } from "@dropbox/dig-foundations";
import classNames from "classnames";

// ../src/layer/index.css.ts
import { createRuntimeFn as _7a468 } from "@vanilla-extract/recipes/createRuntimeFn";
var layer = _7a468({ defaultClassName: "dig-t7j4ze0_21-4-0", variantClassNames: { positioning: { absolute: "dig-t7j4ze1_21-4-0", relative: "dig-t7j4ze2_21-4-0" } }, defaultVariants: { positioning: "relative" }, compoundVariants: [] });

// ../src/layer/layer.tsx
var Layer = React2.forwardRef(
  ({ children, isPortaled = true, _elevateByZ = 1, _preferAbsolute, className, color: _, ...rest }, ref) => {
    if (_elevateByZ <= 0) {
      throw new Error("`_elevateByZ` must be a positive number.");
    }
    const { getThemeProps } = useTheme();
    const contextVal = React2.useContext(LayerContext);
    const [contextZ, contextPortalRoot, contextPreferAbsolute] = React2.useMemo(() => {
      if (contextVal === null) {
        return [void 0, void 0, void 0];
      }
      return [contextVal.zIndex, contextVal.portalRootElement, contextVal.preferAbsolute];
    }, [contextVal]);
    const preferAbsolutePositioning = contextPreferAbsolute !== void 0 ? contextPreferAbsolute : _preferAbsolute;
    const shouldUseAbsolutePositioning = preferAbsolutePositioning && isPortaled === false;
    const cls = classNames(
      "dig-Layer",
      layer({
        positioning: shouldUseAbsolutePositioning ? "absolute" : "relative"
      }),
      {
        "dig-Layer--prefer-absolute": shouldUseAbsolutePositioning
      },
      className
    );
    const parentZ = contextZ || 0;
    const z = parentZ + _elevateByZ;
    const container = /* @__PURE__ */ React2.createElement("div", { ...rest, ref, className: cls, style: { zIndex: z } }, children);
    const portaledContainerWithTheme = /* @__PURE__ */ React2.createElement("div", { ...getThemeProps() }, container);
    return /* @__PURE__ */ React2.createElement(LayerContext.Provider, { value: { zIndex: z, portalRootElement: contextPortalRoot } }, (typeof document !== "undefined" || contextPortalRoot) && isPortaled ? ReactDOM.createPortal(
      portaledContainerWithTheme,
      // By default, all layers are portaled as siblings of each other into the
      // `document.body`. This eliminates all the complexities that comes with the browser's
      // stacking context to simplify how elevation works within the design system to just a
      // matter of a single `zIndex` value.
      // Disabled as we check for document in the condition above
      // eslint-disable-next-line ssr-friendly/no-dom-globals-in-react-fc
      contextPortalRoot || document.body
    ) : container);
  }
);
Layer.displayName = "Layer";
export {
  ELEVATED_BACKDROP_INDEX,
  ELEVATED_BASE_INDEX,
  Layer,
  LayerContext,
  MODAL_BASE_INDEX
};
